(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-sub-menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const subCollectionNav = document.querySelector('.sub-collection-nav');

    if (subCollectionNav) {
      const breadcrumb = document.querySelector('nav.breadcrumb');
      
      if (breadcrumb) {
        breadcrumb.style.display = 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const mainSectionExists = document.querySelector('[data-section-type="collection-template"]');

    if (mainSectionExists) {
      const collectionHero = document.querySelector('.collection-hero');
      const collectionHeader = document.querySelector('header.section-header');
      
      if (collectionHero) {
        collectionHero.style.display = 'none';
      }
      if (collectionHeader) {
        collectionHeader.style.display = 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
